export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 pt-24 pb-12 md:pt-28 md:pb-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-fire-line"></i>
              <span>全网综艺秒播平台</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight mb-4">
              快看影视
              <span className="block text-primary-500 mt-1">
                综艺节目高清在线观看
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-medium mb-6">
              最新综艺、免费综艺大全，不缓冲流畅秒播
            </p>

            <div className="space-y-3 text-foreground-700 text-sm md:text-base leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              <p>
                快看影视是国内领先的综艺节目免费在线观看平台，收录超过3000档热门综艺，
                涵盖户外竞技、音乐选秀、推理探案、美食慢综等全品类内容。
              </p>
              <p>
                每日同步更新最新综艺资源，采用全球CDN加速与智能预加载技术，
                确保高清画质下实现不缓冲、流畅秒播的极致观看体验。
              </p>
              <p>
                2026暑期综艺嘉年华火热进行中，12档王牌综艺轮番登场，
                极限挑战第十季、创造营2026、密室大逃脱第六季等热播综艺一站畅享。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500">3000+</div>
                <div className="text-xs text-foreground-500 mt-1">收录综艺</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500">1.2亿</div>
                <div className="text-xs text-foreground-500 mt-1">月活用户</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600">98.6%</div>
                <div className="text-xs text-foreground-500 mt-1">秒播成功率</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#index')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-xl font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                立即探索综艺
              </button>
              <button
                onClick={() => scrollTo('#app')}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-700 rounded-xl font-semibold text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-300"
              >
                <i className="ri-download-2-line mr-2"></i>
                下载APP观看
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px]">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20vibrant%20collage%20style%20composition%20of%20Chinese%20variety%20show%20elements%2C%20tv%20studio%20lights%2C%20stage%20performances%2C%20outdoor%20adventure%20scenes%2C%20colorful%20entertainment%20atmosphere%2C%20warm%20orange%20and%20amber%20tones%2C%20modern%20streaming%20platform%20aesthetic%2C%20clean%20minimal%20background&width=1040&height=780&seq=hero-main-2026&orientation=landscape"
                  alt="快看影视综艺节目在线观看平台主视觉"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-3 -left-3 bg-background-50 rounded-xl px-4 py-2.5 shadow-sm border border-background-200">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                  <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">
                    实时在线 <strong className="text-primary-500">128万+</strong> 观众
                  </span>
                </div>
              </div>
              <div className="absolute -top-3 -right-3 bg-background-50 rounded-xl px-4 py-2.5 shadow-sm border border-background-200">
                <div className="flex items-center gap-2">
                  <i className="ri-flashlight-line text-accent-500 text-sm"></i>
                  <span className="text-xs font-medium text-foreground-600 whitespace-nowrap">
                    今日更新 <strong className="text-accent-500">47</strong> 档综艺
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}